<template>
	<GlobalStaticContentPage :page="ECMSPage.DOCUMENTS" :title="$t('pages.documents.header')" />
</template>

<script setup lang="ts">
import { ECMSPage } from '@/modules/adminModule/constants/pagesCMSconstants'

usePageViewed(EGTMPageType.DOCUMENTS)
</script>
